import cookie from "react-cookies";
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY || "";

export default class EncryptedCookieGateway {
  static set(key, value, options = {}) {
    try {
      const data = typeof value === "string" ? value : JSON.stringify(value);
      const encryptedValue = CryptoJS.AES.encrypt(data, SECRET_KEY).toString();

      cookie.save(key, encryptedValue, { path: "/", ...options });
    } catch (error) {
      console.error("Error setting encrypted cookie:", error);
    }
  }

static get(key) {
  try {
    const encryptedValue = cookie.load(key);
    if (!encryptedValue) return null;

    const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    if (!decrypted) return null;

    const trimmed = decrypted.trim();
    const firstChar = trimmed[0];

    // ✅ Only try JSON.parse for obvious JSON (object/array)
    if (firstChar === "{" || firstChar === "[") {
      try {
        return JSON.parse(trimmed);
      } catch {
        // If parsing fails, just return the raw string
        return decrypted;
      }
    }

    // ❗ Everything else is returned as-is (string), including:
    // "true", "false", "null", "123", "hello", etc.
    return decrypted;
  } catch (error) {
    console.error("Error reading encrypted cookie:", error);
    return null;
  }
}


  static remove(key, options = {}) {
    try {
      cookie.remove(key, { path: "/", ...options });
    } catch (error) {
      console.error("Error removing encrypted cookie:", error);
    }
  }
}
